// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tooltip';
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import 'select2/dist/js/select2.min';
// import 'simple-icons';
import 'jquery-zoom/jquery.zoom.min';
import 'jquery.resizeend/lib/jquery.resizeend.min';
//import 'letteringjs';



// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js